import { render, staticRenderFns } from "./codeVerification.vue?vue&type=template&id=99667df0&"
import script from "./codeVerification.vue?vue&type=script&lang=js&"
export * from "./codeVerification.vue?vue&type=script&lang=js&"
import style0 from "./codeVerification.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VOtpInput } from 'vuetify/lib/components/VOtpInput';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VCol,VOtpInput,VProgressCircular})
